import React from "react";
import Sidebar from "./Sidebar";
import { useLocation, matchPath } from "react-router-dom";
import "./MainContent.css";
import Page from "@/components/common/Page";
import useAuthStore from "@/stores/user/authStore";
import CookieConsent from "./ui/cookie-consent";
import ScrollToTop from "./ScrollToTop";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const location = useLocation();
  const { initialLoading } = useAuthStore();
  const pagesToShowSidebar = [
    "/lodge",
    "/new-trip",
    "/trip-builder",
    "/active-trips",
    "/tora",
    "/explore",
    "/account",
  ];

  const pagesToHideSidebar = [
    "/login",
    "/signup",
    "/logout",
    "/auth/callback",
    "/protect",
    "/booking",
  ];

  const shouldShowSidebar = () => {
    // First check if path matches any defined routes
    const hasMatchingRoute = [
      ...pagesToShowSidebar,
      ...pagesToHideSidebar,
    ].some((path) => matchPath(path + "/*", location.pathname));

    if (!hasMatchingRoute) return false;

    // Then check if it should show sidebar
    return pagesToShowSidebar.some((path) => {
      const matchesShowPath = location.pathname.startsWith(path);
      const matchesHidePath = pagesToHideSidebar.some((hidePath) =>
        location.pathname.startsWith(hidePath)
      );
      return matchesShowPath && !matchesHidePath;
    });
  };

  const isTripBuilderPage = location.pathname.startsWith("/trip-builder");

  return (
    <main>
      <ScrollToTop />
      {shouldShowSidebar() && !initialLoading ? (
        <div className="flex flex-row w-full">
          <Sidebar isTripBuilderPage={isTripBuilderPage} />
          <Page isTripBuilderPage={isTripBuilderPage}>{children}</Page>
        </div>
      ) : (
        children
      )}
      <CookieConsent />
    </main>
  );
};

export default Layout;
